export const steps = [
    { link: 'what-you-will-need', stepNumber: 1 },
    { link: 'intent', stepNumber: 2 },
    { link: 'employment', stepNumber: 3 },
    { link: 'source-of-funds', stepNumber: 4 },
    { link: 'id-verification', stepNumber: 5 },
    { link: 'pending', stepNumber: 6 },
    { link: 'complete', stepNumber: 7 },
] as const;